import {useCallback, useEffect, useState} from 'react';

type Dimensions = {
  height: number;
  width: number;
};

function getWindowDimensions(): Dimensions {
  const {innerHeight: height, innerWidth: width} = window;

  return {
    height,
    width,
  };
}

export const useWindowDimensions = () => {
  const [windowDimensions, setWindowDimensions] = useState(() =>
    getWindowDimensions(),
  );

  const handleResize = useCallback(() => {
    setWindowDimensions(getWindowDimensions());
  }, []);

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, [handleResize]);

  return windowDimensions;
};
